<script setup lang="ts">
import { computed, onMounted } from 'vue';
import Icon from '@components/icons/icon.vue';
import { Tag } from '@components/tag.js';

const props = withDefaults(defineProps<Tag>(), {
    tagIcon: null,
    tagValue: null,
    tagColor: 'grey',
    tagValueWrap: true,
});

onMounted(() => {
    if (props.tagValue === null && props.tagIcon === null) {
        console.error('empty tag: tag-value or tag-icon has to be set');
    }
});

const icons = computed<Array<string>|null>(() => {
    if (props.tagIcon === null) {
        return null;
    }
    if (!Array.isArray(props.tagIcon)) {
        return [props.tagIcon];
    }
    return props.tagIcon;
});
</script>

<template>
    <p :class="[$style.tag, $style[tagColor]]">
        <span v-if="icons !== null" :class="$style.icons">
            <template v-for="icon in icons">
                <Icon :class="$style.icon" :icon="icon" :icon-color="tagColor === 'yellow' ? 'default' : 'white'"/>
            </template>
        </span>
        <span v-if="tagValue !== null" :class="[$style.text, !tagValueWrap ? $style.text_no_wrap : '']">{{ tagValue }}</span>
    </p>
</template>

<style lang="scss" module>
@use '@text' as *;

.tag {
    display: inline-flex;
    gap: .6em;
    align-items: center;
    justify-content: center;
    padding: .3em .8em;
    font-size: 90%;
    font-weight: $weight-medium;
    text-align: center;
    border-radius: 20px;
    cursor: default;

    &.grey { background-color: #aaa5a5; }
    &.green { background-color: #10bd4c; }
    &.blue { background-color: #2691d9; }
    &.red { background-color: #dc0e15; }
    &.orange { background-color: #ff710b; }
    &.lila { background-color: #d923ed; }
    &.primary { background-color: #17a8ac; }
    &.grey, &.green, &.blue, &.red, &.orange, &.lila, &.primary {
        color: #fff;
        &:hover {
            color: #fff;
        }
    }
    &.yellow {
        background-color: #fcc500;
        color: #243442;
        &:hover {
            color: #243442;
        }
    }
    .text_no_wrap {
        white-space: nowrap;
    }
    .icons {
        display: flex;
        gap: .3em;
        align-items: center;
        justify-content: center;

        .icon {
            height: .9em;
            margin-top: -1px;
            color: inherit;

            &:hover {
                color: inherit;
            }
        }
    }
}
</style>
